// Types
import * as Api from 'api/login';
import {
  INIT,
  SET_CLIENT_UI,
  initAppError,
  initAppSuccess,
  setClient
} from './initActions';
import { all, call, put, select, takeEvery } from 'redux-saga/effects';
import { getAuth, getClientCodeFromLogin, logout } from 'actions/auth/login';
import type { Saga } from 'redux-saga';
import { getClientCode } from 'actions/ui/init/initSelectors';
import { getLocale } from 'actions/language/selectors';
import { ERROR_ACCESS_DENIED } from 'lib/errorTypes';
import { replace } from 'react-router-redux';

/*** Sagas ***/
export function* initializeAsyncStateWorker(): Saga<void> {
  try {
    yield put(initAppSuccess());
  } catch (err) {
    yield put(initAppError(err));
  }
}

export function* initializeAsyncClientWorker(): Saga<void> {
  const auth = yield select(getAuth);
  const locale = yield select(getLocale);
  const consumer = yield select(getClientCode);

  try {
    const clientObject = yield call(Api.getClient, locale, auth, consumer);
    const clientCodeFromLogin = yield select(getClientCodeFromLogin);

    //NOTE: ideally this authorization would be handled in call to the api but for now we're checking requested client code against what's stored when user logs in
    if (auth) {
      //force logout if logged in but persisted login info does not contain clientCode so that we can store it when the user logs back in
      if (!clientCodeFromLogin) {
        yield put(logout());
      } else if (!clientCodeFromLogin.match(RegExp(consumer, 'i'))) {
        //regex for case insensitive comparison
        //if the consumer client code is different from the one saved in authentication information redirect to access denied page
        yield put(replace(`/${locale}/AccessDenied`));
      }
    }

    yield put(setClient(clientObject));
  } catch (err) {
    if (err.id == ERROR_ACCESS_DENIED) {
      //when auth token expired
      yield put(logout());
    } else {
      //TODO currently any other exception is treated as not found (e.g. 5xx errors)
      yield put(replace(`/${locale}/NotFound`));
    }
  }
}

export function* initSaga(): Saga<void> {
  yield all([
    takeEvery(INIT, initializeAsyncStateWorker),
    takeEvery(SET_CLIENT_UI, initializeAsyncClientWorker)
  ]);
}



// WEBPACK FOOTER //
// ./src/actions/ui/init/initSagas.js